import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
// eslint-disable-next-line import/no-cycle
import store from '@/store';
import { UserType } from '.../../../../common/dist/common';

export interface AuthState {
  isLogin: boolean;
  type: UserType;
  name: string;
  sp: boolean;
}

@Module({ dynamic: true, name: 'Auth', store })
export default class Auth extends VuexModule implements AuthState {
  public isLogin = false;
  public type = UserType.None;
  public isAccepted = false;
  public target = 0;
  public name = '';
  public sp = false;

  @Mutation
  public setLogin(
    { isLogin, type, name, sp }:
    { isLogin: boolean; type: UserType; name: string; sp: boolean },
  ) {
    this.isLogin = isLogin;
    this.type = type;
    this.name = name;
    this.sp = sp;
  }

  @Action({})
  public async login({ type, name, sp }: { type: UserType; name: string; sp: boolean }) {
    this.setLogin({ isLogin: true, type, name, sp });
  }

  @Action({})
  public logout() {
    this.setLogin({ isLogin: false, type: UserType.None, name: '', sp: this.sp });
  }
}

export const AuthModule = getModule(Auth);
